import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Grid, Paper, Stack, Tab, Tabs } from '@mui/material';
import {
  loadDriftIgnoreListAsync,
  loadLatestLocatorResultAsync,
  loadLocatorPrioritiesAsync,
  selectActiveTab,
  selectLatestResult,
  selectResultLoading,
  setActiveTab,
} from '../../redux/locatorDrift/locatorDriftSlice';
import AnalyticsDriftTab from './analyticsDrift/AnalyticsDriftTab';
import HealingTab from './healing/HealingTab';
import HistoryTab from './history/HistoryTab';
import ResultsTab from './results/ResultsTab';
import ScreenDriftTab from './screenDrift/ScreenDriftTab';
import VersionDiffTab from './versionDiff/VersionDiffTab';
import { primaryColor, tabItems } from './locatorDriftConstants';

const tabsMap = {
  results: <ResultsTab />,
  history: <HistoryTab />,
  drift: <ScreenDriftTab />,
  analyticsDrift: <AnalyticsDriftTab />,
  healing: <HealingTab />,
  versionDiff: <VersionDiffTab />,
};

export default function LocatorDriftPage() {
  const dispatch = useDispatch();
  const activeTab = useSelector(selectActiveTab);
  const latestResult = useSelector(selectLatestResult);
  const resultLoading = useSelector(selectResultLoading);

  useEffect(() => {
    dispatch(loadLocatorPrioritiesAsync());
    dispatch(loadDriftIgnoreListAsync());
  }, [dispatch]);

  useEffect(() => {
    if (activeTab === 'results' && !latestResult && !resultLoading) {
      dispatch(loadLatestLocatorResultAsync());
    }
  }, [dispatch, activeTab, latestResult, resultLoading]);

  return (
    <Container maxWidth={true}>
      <Stack spacing={2}>
        <Grid container spacing={2} sx={{ minHeight: 'calc(100vh - 190px)' }}>
          <Grid style={{ flex: 1 }}>
            <Paper
              variant="outlined"
              sx={{
                height: '100%',
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                overflow: 'hidden',
              }}
            >
              <Tabs
                value={activeTab}
                onChange={(event, value) => dispatch(setActiveTab(value))}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                  borderBottom: '1px solid #E0E0E0',
                  '& .MuiTab-root': { textTransform: 'none', fontWeight: 700 },
                  '& .Mui-selected': { color: primaryColor },
                  '& .MuiTabs-indicator': { bgcolor: primaryColor },
                }}
              >
                {tabItems.map((tab) => (
                  <Tab key={tab.value} value={tab.value} label={tab.label} />
                ))}
              </Tabs>
              <Box sx={{ flex: 1, overflowY: 'auto', p: 2 }}>{tabsMap[activeTab]}</Box>
            </Paper>
          </Grid>
        </Grid>
      </Stack>
    </Container>
  );
}
